const apiRoutes = {
  SPLASH: "/splash",
  DASHBOARD: "/dashboard",
  INFO: "/info",
  CONTACT_DETAILS: "/contact-details",
  CREATE: "/create",
  SCAN: "/scan",
};

export default apiRoutes;
